import { useState, useEffect } from "react";
/* import { Link } from "react-router-dom"; */

/* import moment from "moment";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { es } from "date-fns/locale"; */

// estilos
import "../../assets/style/componentPrincipal.css";
import "./pptosNew.css";
import "../../assets/style/tablesG.css";
import "./invoice.css";

// componentes
import { Buscar } from "../general/buscadorFacturasVenta/Buscar";
import { ModalProgress } from "../modals/ModalProgress";
import { TableList } from "./tableList";

import { useInvoices } from "../../hooks/useInvoices";
/* import NumberFormat from "react-number-format";
import { useSelector } from "react-redux"; */
import { DateFilters } from "./list/DateFilters";
import { SubMenu } from "./list/SubMenu";
import { BoxTotals } from "./list/BoxTotals";

export const InvoiceList = () => {
  const [loading, setLoading] = useState(true);
  const { invoices, initGetAllInvoices } = useInvoices();

  const [filters, setFilters] = useState({
    time: "all",
    text: "",
    fecha_desde: new Date(),
    fecha_hasta: new Date(),
    check_emitida: true,
    check_pagada: false,
    check_anulada: false,
    check_por_emitir: true,
    id_tipo_documento: "",
    page: 1,
    rows: 10,
    q: "pc",
  });

  const handleChangeDateDesde = (newValue) => {
    setFilters({
      ...filters,
      fecha_desde: newValue,
    });
  };

  const handleChangeDateHasta = (newValue) => {
    setFilters({
      ...filters,
      fecha_hasta: newValue,
    });
  };

  const handleUrl = (queryOption) => {
    if (queryOption === "t") {
      setFilters({
        ...filters,
        q: queryOption,
        check_emitida: true,
        check_pagada: true,
        check_por_emitir: true,
        check_anulada: true,
      });
    } else {
      setFilters({
        ...filters,
        q: queryOption,
        check_emitida: true,
        check_pagada: false,
        check_por_emitir: false,
        check_anulada: false,
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    initGetAllInvoices(filters);
    setLoading(false);
  }, [filters, initGetAllInvoices]);

  return (
    <div className="p-container">
      <h1 className="p-title">Facturas de venta</h1>

      <DateFilters
        filters={filters}
        setFilters={setFilters}
        handleChangeDateDesde={handleChangeDateDesde}
        handleChangeDateHasta={handleChangeDateHasta}
      />

      <div className="row p-box-searching">
        <div className="col d-flex">
          <Buscar filters={filters} setFilters={setFilters} />
        </div>
        <div className="col d-flex justify-content-end"></div>
      </div>

      {loading && <ModalProgress />}

      <SubMenu filters={filters} handleUrl={handleUrl} />

      {/* KPI */}
      {/* <div className="mt-3 mb-4">
        <Totales
          filters={filters}
          setFilters={setFilters}
          data={invoices.totales}
        />
      </div> */}

      <BoxTotals totals={invoices.totales} />

      <TableList
        filters={filters}
        setFilters={setFilters}
        list={invoices.invoices}
      />
    </div>
  );
};

/* 
const Totales = ({ filters, setFilters, data }) => {
  const {
    // local_moneda: moneda,
    local_simbolo: simbolo,
    local_separacion_miles: separacion_miles,
    local_separacion_decimales: separacion_decimales,
  } = useSelector((state) => state.general.info);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="bg-white rounded-2xl shadow p-4">
        <h3 className="text-sm text-gray-500">Total facturado</h3>
        <Link to="" onClick={() => setFilters({ ...filters, view: "flujos" })}>
          <p className="text-xl font-semibold text-gray-600 text-start">
            <NumberFormat
              value={data?.facturado || 0}
              displayType={"text"}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              prefix={`${simbolo} `}
              decimalScale={2}
              fixedDecimalScale={2}
            />
          </p>
        </Link>
      </div>
      <div className="bg-white rounded-2xl shadow p-4">
        <h3 className="text-sm text-gray-500">Cobrado</h3>
        <Link to="" onClick={() => setFilters({ ...filters, view: "flujos" })}>
          <p className="text-xl font-semibold text-green-600 text-start">
            <NumberFormat
              value={data?.cobrado || 0}
              displayType={"text"}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              prefix={`${simbolo} `}
              decimalScale={2}
              fixedDecimalScale={2}
            />
          </p>
        </Link>
      </div>
      <div className="bg-white rounded-2xl shadow p-4">
        <h3 className="text-sm text-gray-500">Por cobrar</h3>
        <p className="text-xl font-semibold text-blue-600">
          <NumberFormat
            value={data?.por_cobrar || 0}
            displayType={"text"}
            thousandSeparator={separacion_miles}
            decimalSeparator={separacion_decimales}
            prefix={`${simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </p>
      </div>
    </div>
  );
};
 */
